<template>
  <div class="btn-wrapper">
    <a
      :href="url"
      v-if="external"
      :rel="relNoFollow"
      target="_blank"
      class="btn to-index"
      >{{ name }}</a
    >
    <nuxt-link :to="url" v-else class="btn to-index">{{ name }}</nuxt-link>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    external: {
      type: Boolean,
      default: false
    },
    nofollow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    relNoFollow() {
      return this.nofollow ? 'nofollow' : ''
    }
  }
}
</script>
